import { sendCommonRequest } from './api';
const defaultRouter = [
    'ppdloanapp://tender/validator',
    'ppdloanapp://account/validatorOrEvaluate',
    'ppdloanapp://dynamicrouter/router?templateType=12',
    'ppdloanapp://dynamicrouter/router3?templateType=12',
];
// 1、异步 判断当前链接是否为 戳额发标路由 （线上apolloUrl，本地defaultRouter兜底）
// 2、如果为 戳额发标路由，上报collect曝光埋点
// 3、入参page、position、idea、source按照pbk格式encode后拼接在链接query参数中（pbk多个字段拼接格式: 页面_位置_创意_场景）
// 4、返回处理后的链接
let apolloUrl = null;
export function collect(url = '', params = {}, extraParams) {
    return new Promise((resolve, reject) => {
        if (url && url.length) {
            if (apolloUrl) {
                resolve(checkUrlParams(url, params, extraParams, apolloUrl));
            } else {
                collectApolloUrl().then(res => {
                    resolve(checkUrlParams(url, params, extraParams, apolloUrl));
                }).catch(err => {
                    resolve(checkUrlParams(url, params, extraParams, defaultRouter));
                });
            }
        } else {
            resolve(url);
        }
    })
};
// 1、同步 判断当前链接是否为 戳额发标路由 (本地默认defaultRouter)
// 2、如果为 戳额发标路由，上报collect曝光埋点
// 3、入参page、position、idea、source按照pbk格式encode后拼接在链接query参数中（pbk多个字段拼接格式: 页面_位置_创意_场景）
// 4、返回处理后的链接
export function syncCollect(url = '', params = {}, extraParams) {
    return checkUrlParams(url, params, extraParams, defaultRouter);
};
function checkUrlParams(url = '', params = {}, extraParams, tempUrlList) {
    try {
        if (tempUrlList.some(item => url.indexOf(item) !== -1)) {
            let { page, position, idea, source } = params;
            page = encodeURIComponent(page || '0');
            position = encodeURIComponent(position || '0');
            idea = encodeURIComponent(idea || '0');
            source = encodeURIComponent(source || '0');
            const pbk = `${page}_${position}_${idea}_${source}`;
            const resultUrl = setObjToUrlParams(url, { ...{ pbk }, ...extraParams })
            singleCollect(resultUrl);
            return resultUrl;
        } else {
            return url;
        }
    } catch (error) {
        return url;
    }
}
// 只上报collect曝光埋点
export function singleCollect(url = '') {
    if (url && url.length) {
        sendCommonRequest('collect', { url });
    }
}
// 参数拼接
function setObjToUrlParams(baseUrl, query) {
    let queryArr = [];
    for (const key in query) {
        if (query.hasOwnProperty(key)) {
            queryArr.push(`${key}=${encodeURIComponent(query[key])}`);
        }
    }
    let urlContent = [];
    let fragmentStr = '';
    if (baseUrl.indexOf('/#/') !== -1) {
        urlContent = baseUrl.split('/#/');
        fragmentStr = '/#/';
    } else if (baseUrl.indexOf('#/') !== -1) {
        urlContent = baseUrl.split('#/');
        fragmentStr = '#/';
    } else {
        urlContent = [baseUrl];
    }
    let prefixUrl = urlContent[0];
    if (prefixUrl.indexOf('?') !== -1) {
        prefixUrl = `${prefixUrl}&${queryArr.join('&')}`;
    } else {
        prefixUrl = `${prefixUrl}?${queryArr.join('&')}`;
    }
    if (urlContent.length > 1) {
        return prefixUrl + fragmentStr + urlContent[1];
    } else {
        return prefixUrl + fragmentStr;
    }
}

// 待定 apollo配置需要校验的路由链接列表
export function collectApolloUrl() {
    return new Promise((resolve, reject) => {
        sendCommonRequest('queryByList', ['loanapp.router.config']).then((res) => {
            if (res && res['loanapp.router.config']) {
                apolloUrl = res['loanapp.router.config'];
                resolve(apolloUrl);
            }
            reject(res);
        }).catch((err) => {
            reject(err);
        });
    });
}